import store from "../store";
import connect_api from "../connect/connect_api";
import notification from "../components/subcomponents/notification";

class apiDB {
  constructor(params) {
    this.api_module = params.api_module;
    this.table_key_name = params.table_key_name;
    this.reducer_name = params.reducer_name;
    this.reducer_var = params.reducer_var;
    this.action_prefix = params.action_prefix;
    if (params.linked_table) this.linked_table = params.linked_table;
    if (params.linked_table_key_name)
      this.linked_table_key_name = params.linked_table_key_name;
  }
  parseResponse(error, response, action_types, callback = null) {
    if (error) {
      if (error.api_error.type === "VALIDATION_ERROR") {
        store.dispatch({
          type: action_types.validation_error,
          data: error.api_error.fields,
        });
      } else if (error.api_error.type === "DB_ERROR") {
      }
      notification.error(error.api_error.message);
      if (typeof callback === "function") {
        callback(error.api_error, false);
      }
    } else {
      store.dispatch({
        type: action_types.success,
        data: response.api_data,
      });
      if (action_types.success_msg)
        notification.success(action_types.success_msg);
      if (typeof callback === "function") {
        callback(false, response.api_data);
      }
    }
  }
  list(callback) {
    let self = this;
    const state = store.getState();
    const action_types = {
      success: this.action_prefix + "_SEARCH",
    };
    let params = {
      search: state[this.reducer_name][this.reducer_var].search_string,
      filter: state[this.reducer_name][this.reducer_var].filter || {},
      list_pagination:
        state[this.reducer_name][this.reducer_var].list_pagination,
    };
    connect_api.sPOST(
      "/" + this.api_module + "/list",
      params,
      function (error, response) {
        self.parseResponse(error, response, action_types, callback);
      }
    );
  }
  linked_list(callback) {
    let self = this;
    const state = store.getState();
    const action_types = {
      success: this.action_prefix + "_LINKED_LIST",
    };
    let obj = {};
    obj[this.linked_table_key_name] =
      state[this.reducer_name][this.linked_table].selected;
    connect_api.sPOST(
      "/" + this.api_module + "/linked_list",
      obj,
      function (error, response) {
        self.parseResponse(error, response, action_types, callback);
      }
    );
  }
  details(callback) {
    let self = this;
    const state = store.getState();
    const action_types = {
      success: this.action_prefix + "_DETAILS",
    };
    let obj = {};
    obj[this.table_key_name] =
      state[this.reducer_name][this.reducer_var].selected;
    connect_api.sPOST(
      "/" + this.api_module + "/single",
      obj,
      function (error, response) {
        self.parseResponse(error, response, action_types, callback);
      }
    );
  }
  get_module(callback) {
    let self = this;
    const state = store.getState();
    const action_types = {
      success: this.action_prefix + "_GET_MODULE",
    };
    let obj = {};
    obj[this.table_key_name] =
      state[this.reducer_name][this.reducer_var].selected;
    connect_api.sPOST(
      "/" + this.api_module + "/get_module",
      obj,
      function (error, response) {
        self.parseResponse(error, response, action_types, callback);
      }
    );
  }
  options() {
    let self = this;
    const action_types = {
      success: this.action_prefix + "_OPTIONS",
    };
    connect_api.sPOST(
      "/" + this.api_module + "/field_options",
      {},
      function (error, response) {
        self.parseResponse(error, response, action_types);
      }
    );
  }
  add(callback) {
    let self = this;
    const state = store.getState();
    const action_types = {
      success: this.action_prefix + "_INSERTED",
      validation_error: this.action_prefix + "_VALIDATION_ERROR",
      operation_error: this.action_prefix + "_INSERT_ERROR",
      success_msg: "Record added",
    };
    connect_api.sPOST(
      "/" + this.api_module + "/add",
      state[this.reducer_name][this.reducer_var].details,
      function (error, response) {
        self.parseResponse(error, response, action_types, callback);
      }
    );
  }
  update(callback) {
    let self = this;
    const state = store.getState();
    const action_types = {
      success: this.action_prefix + "_UPDATED",
      validation_error: this.action_prefix + "_VALIDATION_ERROR",
      operation_error: this.action_prefix + "_UPDATED_ERROR",
      success_msg: "Record updated",
    };
    connect_api.sPOST(
      "/" + this.api_module + "/update",
      state[this.reducer_name][this.reducer_var].details,
      function (error, response) {
        self.parseResponse(error, response, action_types, callback);
        //TODO: if (self.update_list_on_edit) self.list();
      }
    );
  }
  del(callback) {
    let self = this;
    const state = store.getState();
    const action_types = {
      success: this.action_prefix + "_DELETED",
      validation_error: this.action_prefix + "_VALIDATION_ERROR",
      operation_error: this.action_prefix + "_DELETE_ERROR",
      success_msg: "Record deleted",
    };
    if (state[this.reducer_name][this.reducer_var].selected) {
      let obj = {};
      obj[this.table_key_name] =
        state[this.reducer_name][this.reducer_var].selected;
      connect_api.sPOST(
        "/" + this.api_module + "/del",
        obj,
        function (error, response) {
          self.parseResponse(error, response, action_types, callback);
        }
      );
    } else {
      callback("Nothing selected", false);
    }
  }
}

export default apiDB;
